import { HeroIllustrationPaths } from './HeroIllustrationPaths';
import { HeroIllustrationPathsRTL } from './HeroIllustrationPathsRTL';
import styles from './Hero.module.scss';

export type HeroIllustrationVariant = 'dark' | 'light';

interface HeroIllustrationProps {
  variant: HeroIllustrationVariant;
  className?: string;
  isRTL?: boolean;
}

const VARIANT_CLASS: Record<HeroIllustrationVariant, string> = {
  dark: styles.illustrationDark,
  light: styles.illustrationLight,
};

export function HeroIllustration({ variant, className, isRTL = false }: HeroIllustrationProps) {
  return (
    <svg
      data-testid="hero-illustration"
      data-variant={variant}
      className={[className, VARIANT_CLASS[variant]].filter(Boolean).join(' ')}
      viewBox="0 0 1440 1103"
      preserveAspectRatio="xMaxYMin meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {isRTL ? <HeroIllustrationPathsRTL /> : <HeroIllustrationPaths />}
    </svg>
  );
}
